import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getAllStaffMembers = createAsyncThunk(
    'staffMember/getAllStaffMembers',
    async ({ skip, limit, search, status, role_name }, { rejectWithValue }) => {
        try {
            const params = {};
            if (skip !== undefined) params.skip = skip;
            if (limit !== undefined) params.limit = limit;
            if (search) params.search = search;
            if (status) params.status = status;
            if (role_name) params.role_name = role_name;

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
                params,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/users`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    response: {
                        data: {
                            message: "Network Error",
                            status: err.code,
                            statusText: err.code,
                        },
                    },
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const addNewStaffMember = createAsyncThunk(
    'staffMember/addNewStaffMember',
    async (staffMemberData, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const body = JSON.stringify(staffMemberData);

            const response = await axios.post(`${PUBLIC_BASE_URL}/users/create-coordinator`, body, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    success: false
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
);

export const editStaffMember = createAsyncThunk(
    'staffMember/editStaffMember',
    async (updatedData, { rejectWithValue }) => {
        try {

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const body = JSON.stringify(updatedData);
            const response = await axios.put(`${PUBLIC_BASE_URL}/users/update-user-info`, body, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    success: false
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
);

export const addNewMentor = createAsyncThunk(
    'staffMember/addNewMentor',
    async (mentorData, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const body = JSON.stringify(mentorData);

            const response = await axios.post(`${PUBLIC_BASE_URL}/users/create-mentor`, body, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    success: false
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
);

export const getMentorById = createAsyncThunk(
    'staffMember/getMentorById',
    async ({ id }, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/users/mentor/${id}`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    response: {
                        data: {
                            message: "Network Error",
                            status: err.code,
                            statusText: err.code,
                        },
                    },
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);
